import React from 'react';

export default function Badge({ color, children, square, variant }) {
  return (
    <span
      className={`docpro_badge docpro_badge_${color ? color : 'olive'} ${
        square ? 'docpro_square' : ''
      } ${variant ? variant : ''}`}
    >
      {children}
    </span>
  );
}
